<template lang="pug">
.card-inteligencia-territorial-dados-gerais-imoveis
    .card-inteligencia-territorial-imoveis-interno--texto
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width: 100%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.vegetacaoNativa') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo {{ formatoNumero(areaTotal.areaVegetacaoNativaCarHa) }} ha
    
    .separador-personalizado
    .card-inteligencia-territorial-imoveis-interno--texto
        .recuo-avancado
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 100%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.classificacao') }}

    .card-inteligencia-territorial-imoveis-interno--colunas.ml-2
        .card-inteligencia-territorial-imoveis-interno--texto
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 22%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.areaPreservacaoPermanente') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(style='width: 22%;')
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 16%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.areaReservaLegal') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.red {{ formatoNumero(0) }} ha
            .card-inteligencia-territorial-imoveis-interno--titulo(style='width: 22%;')
            .card-inteligencia-territorial-imoveis-interno--titulo(
                style='width: 15%'
            ) {{ $t('mensagens.inteligenciaTerritorial.imovel.excedente') }}
                .card-inteligencia-territorial-imoveis-interno--valor
                    span.conteudo-informativo.mt-4.red {{ formatoNumero(0) }} ha
</template>
<script>
import formatters from '@/utils/formatters';

export default {
    name: 'CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel',
    props: {
        areaTotal: {
            type: Object,
            default: () => {
            }
        }
    },

    data() {
        return {};
    },

    methods: {
        formatoNumero(number) {
            return number ? formatters.formatNumber(number, 2) : 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.card-inteligencia-territorial-dados-gerais-imoveis {
    height: 225px;
    border-radius: 8px;
    background: var(--white);
    padding: 7px 15px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;

    .card-inteligencia-territorial-imoveis-interno--colunas {
        display: flex;
        justify-content: flex-start;
    }

    .card-inteligencia-territorial-imoveis-interno--titulo {
        padding-top: 0px;
        font-size: 16px;
        font-weight: 400;
        flex-wrap: wrap;
        margin-top: 10px;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }

    .card-inteligencia-territorial-imoveis-interno--texto {
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        min-height: 50px;
        margin-left: 12px;
        width: 100%;
        color: #3B3B3B;

        span {
            margin-top: 6px;
        }

        .recuo-avancado {
            margin-left: 8px;
        }
    }

    .card-inteligencia-territorial-imoveis-interno--valor {
        display: flex;
        padding-top: 1px;
        margin-bottom: 5px;
    }

    .separador-personalizado {
        border: 2px;
        width: 45px;
        margin: auto;
        border-top: 3px solid var(--secondary-two);
        margin-left: 20px;
    }

    .conteudo-informativo {
        font-size: 18px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        margin-bottom: 10px;
        color: var(--primary);
    }

    .red {
        color: red;
    }
}
</style>
